import { APP_INITIALIZER, Provider } from '@angular/core';
import { environment } from '@environments/environment';
import { MNZ_PLATFORM } from '@mnz-core/injectors/platform';
import { Platform } from '@mnz-core/models/_enums';
import * as Sentry from '@sentry/browser';

export function sentryLoggerFactory(platform: Platform): () => void {
  return (): void => {
    const { production, sentry, version } = environment;
    const { key, projectId } = sentry;

    const config: Sentry.BrowserOptions = {
      enabled: production,
      dsn: `https://${key}@sentry.io/${projectId}`,
      release: version,
      environment: platform,
      blacklistUrls: [/.+(lib|js).+/i, /^chrome:\/\//i],
      ignoreErrors: ['Blocked a frame with origin']
    };

    Sentry.init(config);

    if ([Platform.TEST, Platform.ACCEPTANCE].includes(platform)) {
      console.log(`Running Mijn NS Zakelijk version: ${version}`);
      if (config.enabled) {
        console.log(`Sentry is setup with config: `, { config });
      }
    }
  };
}

export function provideSentryLogger(): Provider {
  return {
    provide: APP_INITIALIZER,
    useFactory: sentryLoggerFactory,
    multi: true,
    deps: [MNZ_PLATFORM]
  };
}
